import { render, staticRenderFns } from "./addGiftCodeLevel.vue?vue&type=template&id=edfe18fa&scoped=true&"
import script from "./addGiftCodeLevel.vue?vue&type=script&lang=js&"
export * from "./addGiftCodeLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe18fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edfe18fa')) {
      api.createRecord('edfe18fa', component.options)
    } else {
      api.reload('edfe18fa', component.options)
    }
    module.hot.accept("./addGiftCodeLevel.vue?vue&type=template&id=edfe18fa&scoped=true&", function () {
      api.rerender('edfe18fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/giftCodeManage/giftCodeLevel/component/addGiftCodeLevel.vue"
export default component.exports